export const CONTROL_PLANE_TENANT_ID = '11aa1aaa-1aa1-1111-aa11-11111a11111a';
